import React from 'react';

const LoginIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32.011" viewBox="0 0 32 32.011">
      <path d="M31.6 22.966a1.6 1.6 0 0 0-2.145.72 12.8 12.8 0 1 1 0-11.363 1.61 1.61 0 1 0 2.881-1.44 16 16 0 1 0 0 14.243 1.6 1.6 0 0 0-.736-2.16zm.8-6.562H17.057l3.681-3.665a1.607 1.607 0 0 0-2.273-2.273l-6.4 6.4a1.654 1.654 0 0 0 0 2.273l6.4 6.4a1.607 1.607 0 1 0 2.273-2.273L17.057 19.6H32.4a1.6 1.6 0 0 0 0-3.2z" transform="translate(-2.005 -1.999)" fill="currentColor"/>
    </svg>
  );
};

export default LoginIcon;
